import { Box, Typography, useTheme } from '@mui/material';
import { CustomSwitch, FormControlDefault, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import React from 'react';
import { translate } from 'react-jhipster';

export const ActivatedSwitch = ({ checked, setChecked, handleInputChange }) => {
  const theme = useTheme();

  const handlechecked = () => {
    setChecked(!checked);
    handleInputChange('activated', !checked);
  };

  return (
    <FormControlDefault>
      <TypographyForms>{translate('fleetSenseApp.truckImplement.status')}</TypographyForms>
      <Box display={'flex'} alignItems={'center'}>
        <Typography color={theme.palette.text.primary}>Inativado</Typography>
        <CustomSwitch sx={{ color: theme.palette.secondary.main }} checked={checked} onChange={handlechecked} />
        <Typography color={theme.palette.text.primary}>Ativado</Typography>
      </Box>
    </FormControlDefault>
  );
};
